import { useCallback } from 'react'
import { atom, useSetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

export const modeAtom = atom<'' | 'qa'>({
  key: '@app/mode',
  default: '',
  effects: [localStorageEffect('@app/mode')],
})

let clickCount = 0

export function useQaClick() {
  const setMode = useSetRecoilState(modeAtom)
  return useCallback(
    () =>
      setMode((mode) => {
        // Only count clicks if not in QA mode
        if (mode !== 'qa') clickCount++
        // Reset click count when going into QA mode
        if (clickCount > 4) {
          clickCount = 0
          return 'qa'
        }
        return mode
      }),
    [],
  )
}
